if (!customElements.get('dbtfy-size-chart')) {
  customElements.define('dbtfy-size-chart', class extends HTMLElement {
    constructor() {
      super();
      this.modalInstance = null;
      this.popupSize = null;
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.originalContent = null;
    }

    connectedCallback() {
      this.designMode = Shopify.designMode;
      
      // Get modal content element
      const modalContent = this.querySelector('.dbtfy-size-chart');
      
      // Get popup size from content element
      this.popupSize = modalContent?.getAttribute('data-popup-size') || 'medium';
      
      // Store original content
      if (modalContent) {
        this.originalContent = modalContent.innerHTML;
      }
      
      // Setup event delegation
      this.addEventListener('click', this.handleButtonClick);
      
      // Initialize modal
      this.initModal();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleButtonClick);
      if (this.modalInstance) {
        this.modalInstance.destroy();
      }
    }

    handleButtonClick(event) {
      if (event.target.closest('#open-size-chart')) {
        this.openModal();
      }
    }

    initModal() {
      if (!this.originalContent) return;
      
      // Destroy existing modal if any
      if (this.modalInstance) {
        this.modalInstance.destroy();
      }
      
      try {
        // Create modal instance with correct size
        this.modalInstance = new Debutify.modal({
          selector: null,
          size: this.popupSize, // Use stored size
          closeMethods: ['overlay', 'button', 'escape'],
          closeIcon: '',
          boxClass: [],
          overlayClass: [],
          onOpen: () => {},
          onClose: () => {}
        });
        
        // Set content from stored original
        this.modalInstance.setContent(this.originalContent);
      } catch (error) {
        console.error('Modal initialization failed:', error);
      }
    }

    openModal() {
      // Reinitialize modal to ensure fresh content
      this.initModal();
      
      if (this.modalInstance && typeof this.modalInstance.open === 'function') {
        this.modalInstance.open();
      } else {
        // Fallback to showing the original content
        const modalContent = this.querySelector('.dbtfy-size-chart');
        if (modalContent) {
          modalContent.classList.remove('hidden');
          document.body.classList.add('dbtfy-modal-open');
          
          // Apply size class manually for fallback
          const sizeClass = `dbtfy-modal-box--${this.popupSize}`;
          const modalBox = modalContent.querySelector('.dbtfy-modal-box');
          if (modalBox) {
            modalBox.classList.add(sizeClass);
          }
        }
      }
    }
  });

//     // size calculate
//   class CustomSizeGuide extends HTMLElement {
//     constructor() {
//       super();
//       this.toggleButtons = null;
//       this.sizeUnitCells = null;
//       this.activeUnit = "inches"; // Default active unit
//       this.unitConversionFactor = 2.54; // 1 inch = 2.54 cm
//       this.originalValues = [];
//     }
  
//     connectedCallback() {
//       this.initializeElements();
//       this.extractValues();
//       this.init();
//     }
  
//     initializeElements() {
//       this.toggleButtons = this.querySelectorAll(".js-unit-trigger");
//       this.sizeUnitCells = this.querySelectorAll(".js-size-chart-unit");
//     }
  
//     extractValues() {
//       this.originalValues = Array.from(this.sizeUnitCells).map(cell => {
//         const dataSize = cell.getAttribute("data-size");
  
//         // Handle missing data ("-" or empty)
//         if (!dataSize || dataSize.trim() === "-") {
//           return null;
//         }
  
//         const [min, max] = dataSize.split(" - ").map(Number);
  
//         // Handle invalid numbers
//         if (isNaN(min) || isNaN(max)) {
//           return null;
//         }
  
//         return { min, max }; // Store valid numeric values
//       });
  
//       this.updateSizeChart(); // Initialize values on load
//     }
  
//     init() {
//       this.toggleButtons.forEach(button => {
//         button.addEventListener("click", () => this.updateActiveUnit(button));
//       });
//     }
  
//     updateActiveUnit(button) {
//       const selectedUnit = button.getAttribute("data-size-unit");
//       if (selectedUnit === this.activeUnit) return; // Do nothing if already selected
  
//       this.activeUnit = selectedUnit;
//       this.toggleButtonStyles(button);
//       this.updateSizeChart();
//     }
  
//     toggleButtonStyles(activeButton) {
//       this.toggleButtons.forEach(button => {
//         button.classList.toggle("is-active", button === activeButton);
//       });
//     }
  
//     updateSizeChart() {
//       const isCm = this.activeUnit === "cm";
  
//       this.sizeUnitCells.forEach((cell, index) => {
//         const value = this.originalValues[index];
  
//         // Skip cells with invalid or missing data
//         if (!value) {
//           cell.textContent = "-";
//           return;
//         }
  
//         const { min, max } = value;
//         const convertedMin = isCm ? (min * this.unitConversionFactor).toFixed(1) : min;
//         const convertedMax = isCm ? (max * this.unitConversionFactor).toFixed(1) : max;
  
//         cell.textContent = `${convertedMin} - ${convertedMax}`; // Removed the unit label
//       });
//     }
//   }
  
//   customElements.define("size-guide", CustomSizeGuide);
  
}